import $ from "jquery"
import "plugins/select2"
import _bind from "lodash/bind"
import { EventEmitter } from "events"

import {
  captureMessage,
} from "app/error_reporting/index"

import fa_angle_factory from "components/icons/fa_angle"

export interface Selector {
  scope:        string | Element | JQuery
  main:         string | Element | JQuery
  arrow:        string | Element | JQuery
  first_option: string | Element | JQuery
}

export interface InputSelector {
  scope?:        string | Element | JQuery
  main?:         string | Element | JQuery
  arrow?:        string | Element | JQuery
  first_option?: string | Element | JQuery
}

const DEFAULT_SELECTOR = {
  scope:        ".control-group",
  main:         ".js-selectpicker",
  arrow:        ".select2-selection__arrow b[role=\"presentation\"]",
  first_option: "option:nth-of-type(1)",
}


class JSSelectPicker extends EventEmitter {
  protected selector: Selector

  protected $scope: JQuery
  protected $el: JQuery

  protected default_option: any

  constructor(selector: InputSelector, use_new_angle = true as boolean) {
    super()

    this.selector = Object.assign({}, DEFAULT_SELECTOR, selector)
    this.$scope = $(this.selector.scope)
    // Stupid TS definition
    this.$el = typeof this.selector.main === "string" ?
      this.$scope.find(this.selector.main) :
      this.$scope.find(this.selector.main)
    if (this.$el.length !== 1) {
      captureMessage(
        `JSSelectPicker init with ${this.$el.length} element is unexpected`,
        {
          source_file_path: "app/assets/javascripts/components/dropdown_menu/neighbourhood_select/with_territory.es6",
          element_paths:    this.$el.toArray().map((suspect_el) => {
            const rightArrowParents = [] as string[]
            $(suspect_el).parents().addBack().not("html").each((_idx, el) => {
              let entry = el.tagName.toLowerCase()
              if (el.id.length > 0) {
                entry += "#" + el.id.trim()
              }
              if (el.className) {
                entry += "." + el.className.trim().replace(/ /g, ".")
              }
              rightArrowParents.push(entry)
            })
            return rightArrowParents.join(" ")
          }).join("\n"),
        }
      )
      throw new Error("JSSelectPicker init with 0 or multiple element")
    }
    import(
      "select2/dist/js/select2.full"
    )
    .then(() => {
      this.$el.select2(
        Object.assign(
          {
            minimumResultsForSearch:  Infinity,
            dropdownParent:           this.$scope,

            containerCssClass:  this.$el.data("container-css-class"),
            dropdownCssClass:   this.$el.data("dropdown-css-class"),
          },
          this.extra_select2_options(),
        )
      )
    })
    this.default_option = this.$el.find(this.selector.first_option).val()
    if (use_new_angle) {
      this.replace_angle()
    }

    this.bind_action()
  }

  public val(new_val?: string|string[]|number){
    if (new_val != null) {
      this.$el.val(new_val)
    }
    else {
      return this.$el.val()
    }
  }
  public reset(){
    this.$el.val(this.default_option)
    this.$el.trigger("change.select2")
    return this
  }
  public isDefault(){
    return this.$el.find("option:selected").val() === this.default_option
  }

  protected bind_action(){
    this.$el.on("change", () => {
      this.onChange(this.$el.val())
    })
    this.$el.on("change.select2", () => {
      this.onDummyChange(this.$el.val())
    })
  }

  protected onChange(val: any){
    // nothing
  }
  protected onDummyChange(val: any){
    // nothing
  }

  protected extra_select2_options(): Select2.Options {
    return {}
  }
  protected name() {
    return this.$el.attr("name") as string
  }

  private replace_angle(){
    const new_angle = $("<i class=\"fa fa-angle-down icon\">")

    this.$scope.find(this.selector.arrow)
    .replaceWith(new_angle)

    const faAngle = fa_angle_factory.create(new_angle)
    this.$el.on("select2:open", _bind(faAngle.open, faAngle))
    this.$el.on("select2:close", _bind(faAngle.close, faAngle))

    return this
  }
}

const Factory = {
  create(selector: InputSelector, use_new_angle?: boolean) {
    return new JSSelectPicker(selector, use_new_angle)
  },
}

export {
  Factory as default,
  Factory,
  JSSelectPicker,
}
